<template>
  <div class="template-custom-footer">
    <div v-for="(item, index) in value" :key="index">
      <div v-html="item"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: [],
    },
  },
}
</script>

<style lang="scss">
.template-custom-footer {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  grid-gap: 2rem;

  img {
    max-width: 100%;
  }

  & > div {
    max-width: 450px;
  }
}
</style>
